export default () => {
  const init = () => {
    customElements.define("address-form", AddressForm);
  };

  init();
};

class AddressForm extends HTMLElement{
  constructor(){
    super()
    this.handleEditButtonClick = this.handleEditButtonClick.bind(this);
    this.handleAddButtonClick = this.handleAddButtonClick.bind(this);
    this.handleCancelButtonClick = this.handleCancelButtonClick.bind(this);
    this.handleDeleteButtonClick = this.handleDeleteButtonClick.bind(this);
    this.handleCountrySelector = this.handleCountrySelector.bind(this);
    this.initializeAddressForm = this.initializeAddressForm.bind(this);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
    this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
    this.updateDefaultAddress = this.updateDefaultAddress.bind(this);
    this.translations = window.SS.Strings.errorsMessage;
  }

  connectedCallback(){
    this.initializeElements();
    this.attachEventListeners();
  }

  disconnectedCallback() {
    this.removeEventListeners();
  }

  initializeElements(){
    this.addressList = this.querySelector('#AddressesList') || null;
    this.editButtons = this.querySelectorAll('button[aria-controls]') || null;
    this.addButton = this.querySelector('#AddNewAddressButton') || null;
    this.cancelButtons = this.querySelectorAll('button[type="reset"]') || null;
    this.deleteButtons = this.querySelectorAll('button[data-confirm-message]') || null;
    this.countrySelector = this.querySelectorAll('[data-address-country]') || null;
    this.provinceSelector = this.querySelectorAll('[data-address-province]') || null;
    this.provinceBlock = this.querySelectorAll('.province-block') || null;
    this.addAddressForm = this.querySelector('#AddAddress') || null;
    this.editAddressForm = this.querySelectorAll('[data-edit-address]') || null;
    this.firstNameInput = this.querySelectorAll('.first-name-input') || null;
    this.lastNameInput = this.querySelectorAll('.last-name-input') || null;
    this.addressInput = this.querySelectorAll('.address-input') || null;
    this.cityInput = this.querySelectorAll('.city-input') || null;
    this.zipInput = this.querySelectorAll('.zip-input') || null;
    this.errorElements = {
      firstName: this.querySelectorAll('.first-name-error'),
      lastName: this.querySelectorAll('.last-name-error'),
      address: this.querySelectorAll('.address-error'),
      city: this.querySelectorAll('.city-error'),
      zip: this.querySelectorAll('.zip-error')
    };
    this.checkboxes = this.querySelectorAll('.default-address-toggle');
  }

  attachEventListeners(){
    this.editButtons.forEach((element, index) => {
      element.addEventListener('click', () => this.handleEditButtonClick(index));
    });
    this.addButton.addEventListener('click', this.handleAddButtonClick);
    this.cancelButtons.forEach((element, index) => {
        element.addEventListener('click', () => this.handleCancelButtonClick(index));
    });
    this.deleteButtons.forEach((element) => {
        element.addEventListener('click', (event) => this.handleDeleteButtonClick(event.currentTarget));
    });
    this.addAddressForm?.addEventListener('submit', (event) => this.handleFormSubmit(event));
    this.editAddressForm?.forEach(form => form.addEventListener('submit', (event) => this.handleFormSubmit(event)));
    this.attachInputValidation(
      this.firstNameInput,
      this.errorElements.firstName,
      this.translations.firstNameErrorMessage
    );
    this.attachInputValidation(this.lastNameInput, this.errorElements.lastName, this.translations.lastNameErrorMessage);
    this.attachInputValidation(this.addressInput, this.errorElements.address, this.translations.addressErrorMessage);
    this.attachInputValidation(this.cityInput, this.errorElements.city, this.translations.cityErrorMessage);
    this.attachInputValidation(this.zipInput, this.errorElements.zip, this.translations.zipErrorMessage);

    this.checkboxes.forEach(checkbox => {
      checkbox.addEventListener('change', (e) => this.handleCheckboxChange(e));
    })
  }

  removeEventListeners(){
    this.editButtons.forEach((element) => {
    element.removeEventListener('click', this.handleEditButtonClick);
    });
    this.addButton.removeEventListener('click', this.handleAddButtonClick);
    this.cancelButtons.forEach((element) => {
        element.removeEventListener('click', this.handleCancelButtonClick);
    });
    this.deleteButtons.forEach((element) => {
        element.removeEventListener('click', this.handleDeleteButtonClick);
    });
    this.countrySelector.removeEventListener('change', this.handleCountrySelector);
    this.addAddressForm?.removeEventListener('submit', this.handleFormSubmit);
    this.editAddressForm?.forEach(form => form.removeEventListener('submit', this.handleFormSubmit));
  }

  handleCheckboxChange(e) {
    const checkbox = e.target;

    let addressId;

    const addressWrapper = checkbox.closest('.address-wrapper');
    const editForm = checkbox.closest('[data-edit-address]');
    const listItem = checkbox.closest('[data-address-id]');

    if (addressWrapper && addressWrapper.dataset.addressId) {
      addressId = addressWrapper.dataset.addressId;
    } else if (editForm && editForm.dataset.addressId) {
      addressId = editForm.dataset.addressId;
    } else if (listItem && listItem.dataset.addressId) {
      addressId = listItem.dataset.addressId;
    } else {
      return;
    }

    if (checkbox.checked) {
      this.checkboxes.forEach(cb => {
        const checkCheckbox = cb;
          if (checkCheckbox !== checkbox) checkCheckbox.checked = false;
      });
      if (editForm){
        const editUpdateBtn = editForm.querySelector('button');
        editUpdateBtn.addEventListener('click', (event) => {
          event.preventDefault();
          this.updateDefaultAddress(addressId)
        });
      } else {
        this.updateDefaultAddress(addressId);
      }
    } else {
      this.handleUncheck(addressId, checkbox);
    }
  }

  handleUncheck(addressId, checkbox) {
    const nextDefault = Array.from(this.checkboxes)
      .find(cb => {
        const wrapperId = cb.closest('.address-wrapper')?.dataset.addressId;
        const formId = cb.closest('[data-edit-address]')?.dataset.addressId;
        const listItemId = cb.closest('[data-address-id]')?.dataset.addressId;
        return (wrapperId || formId || listItemId) !== addressId;
      });

    const checkboxInEditForm = checkbox.closest('[data-edit-address]');

    if (nextDefault) {
      nextDefault.checked = true;
      const nextAddressId = nextDefault.closest('.address-wrapper')?.dataset.addressId
        || nextDefault.closest('[data-edit-address]')?.dataset.addressId
        || nextDefault.closest('[data-address-id]')?.dataset.addressId;
      if (checkboxInEditForm){
        const editUpdateBtn = checkboxInEditForm.querySelector('button');
        editUpdateBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.updateDefaultAddress(nextAddressId)
        });
      } else {
        this.updateDefaultAddress(nextAddressId);
      }
    } else {
      const currentCheckbox = this.querySelector(`[data-address-id="${addressId}"] .default-address-toggle`);
      if (currentCheckbox) currentCheckbox.checked = true;
    }
  }

  updateDefaultAddress(addressId) {
      const form = document.getElementById(`address_form_${addressId}`);
      if (!form) {
          return;
      }

      form.submit();
  }

  attachInputValidation(inputs, errors, errorMessage) {
    inputs.forEach((input, index) => {
      input.addEventListener('input', () => this.validateInput(input, errors[index], errorMessage));
    });
  }  

  validateInput(inputElement, errorElement, errorMessage) {
    const isValid = inputElement.value.trim().length > 0;
    const error = errorElement;
    
    if (!isValid) {
      error.textContent = errorMessage;
      inputElement.classList.add('error-message');
    } else {
      error.textContent = '';
      inputElement.classList.remove('error-message');
    }
    return isValid;
  }

  validateForm(event) {
    let isValid = true;
    const form = event.target.closest('form');
  
    const inputGroups = [
      { inputs: form.querySelectorAll('[name="address[first_name]"]'), errors: form.querySelectorAll('.first-name-error'), translations: this.translations.firstNameErrorMessage },
      { inputs: form.querySelectorAll('[name="address[last_name]"]'), errors: form.querySelectorAll('.last-name-error'), translations: this.translations.lastNameErrorMessage },
      { inputs: form.querySelectorAll('[name="address[address1]"]'), errors: form.querySelectorAll('.address-error'), translations: this.translations.addressErrorMessage },
      { inputs: form.querySelectorAll('[name="address[city]"]'), errors: form.querySelectorAll('.city-error'), translations: this.translations.cityErrorMessage },
      { inputs: form.querySelectorAll('[name="address[zip]"]'), errors: form.querySelectorAll('.zip-error'), translations: this.translations.zipErrorMessage }
    ];
  
    inputGroups.forEach(group => {
      group.inputs.forEach((input, index) => {
        const inputValid = this.validateInput(input, group.errors[index], group.translations);
        if (!inputValid) {
          isValid = false;
        }
      });
    });
  
    return isValid;
  }

  handleFormSubmit(event) {
    if (this.validateForm(event)) {
      event.target.submit();
    } else {
      event.preventDefault();
    }
  }

  handleEditButtonClick(index) {
    this.addressList.classList.add('hidden');
    this.editAddressForm[index].classList.remove('hidden');
    this.editAddressForm[index].classList.add('block');
    this.setupForm();
  }

  handleAddButtonClick(){
    this.addressList.classList.add('hidden');
    this.addAddressForm.classList.remove('hidden');
    this.addAddressForm.classList.add('flex');
    this.setupForm();
  }

  setupForm() {
    this.initializeAddressForm();
    this.countrySelector.forEach((element) => {
      element.addEventListener('change', this.handleCountrySelector);
    });
  }

  handleCountrySelector() {
    this.countrySelector.forEach((countrySelector, index) => {
      const selectedCountry = countrySelector.value;
      const provincesData = countrySelector.querySelector(`option[value="${selectedCountry}"]`).getAttribute('data-provinces');
  
      try {
        const provinces = JSON.parse(provincesData);
        if (provinces && provinces.length > 0) {
          const currentProvinceValue = this.provinceSelector[index].value;
          this.updateProvinceSelector(this.provinceSelector[index], provinces, currentProvinceValue);
          this.provinceBlock[index].classList.remove('hidden');
        } else {
          throw new Error('Empty provinces array');
        }
      } catch (error) {
        this.provinceBlock[index].classList.add('hidden');
      }
    });
  }
  
  updateProvinceSelector(provinceSelector, provinces, currentProvinceValue) {
    const selector = provinceSelector;
    selector.innerHTML = '';
    provinces.forEach(provinceArray => {
      if (provinceArray.length > 0) {
        const provinceName = provinceArray[0];
        const option = document.createElement('option');
        option.value = provinceName;
        option.textContent = provinceName;
        if (provinceName === currentProvinceValue) {
          option.selected = true;
        }
        selector.appendChild(option);
      }
    });
  }
  
  initializeAddressForm() {
    this.countrySelector.forEach((countrySelector, index) => {
      const countryBlock = countrySelector.closest('.country-block');
      
      if (countryBlock) {
        const savedCountry = countryBlock.dataset.country;
        const savedProvince = countryBlock.dataset.province;
        
        if (savedCountry) {
          const option = countrySelector.querySelector(`option[value="${savedCountry}"]`);
          if (option) {
            option.selected = true;
          }
          
          this.handleCountrySelector();
          
          if (savedProvince) {
            const provinceSelector = this.provinceSelector[index];
            if (provinceSelector) {
              const provinceOption = provinceSelector.querySelector(`option[value="${savedProvince}"]`);
              if (provinceOption) {
                provinceOption.selected = true;
              }
            }
          }
        }
      }
    });
  }

  handleCancelButtonClick(index){
    this.addressList.classList.remove('hidden');
    this.editAddressForm[index].classList.add('hidden');
    this.editAddressForm[index].classList.remove('block');
  }

  handleDeleteButtonClick(currentTarget) {
    // eslint-disable-next-line
    if (window.confirm(currentTarget.getAttribute('data-confirm-message'))) {
      Shopify.postLink(currentTarget.dataset.target, {
        parameters: { _method: 'delete' },
      });
    }
  }
}